import React from 'react';

const SvgAlertEmptyTriangle = props => (
  <svg viewBox="0 0 390 390" {...props}>
    <path
      className="alert-empty-triangle_svg__st0"
      d="M194.9 0L0 390h390L194.9 0z"
    />
  </svg>
);

export default SvgAlertEmptyTriangle;
